<ng-template #bulkUploadModalTemplate>
    <div class="modal-header">
        <h4 class="modal-title">{{ "imeis.list.bulkUploadModal.title" | translate }}</h4>
    </div>
    <div class="modal-body row">
        <div class="col-md-12">
            <div class="form-group">
                <label>{{ "imeis.props.productType" | translate }}</label>
                <ng-select name="productType" [items]="productTypes" placeholder="" bindLabel="name" bindValue="key" [clearable]="false" [(ngModel)]="selectedProductTypeKey"> </ng-select>
                <i class="form-group__bar"></i>
                <div class="invalid-tooltip">
                    {{ "imeis.detail.validation.productType" | translate }}
                </div>
            </div>
        </div>
        <input #fileInput type="file" (change)="handleFileInput($event)" style="display: none" />
    </div>
    <div class="modal-footer">
        <button class="btn btn-link" (click)="fileInput.click()">{{ "imeis.list.upload" | translate }}</button>
        <button class="btn btn-link" (click)="bulkUploadModalRef?.hide()">{{ "global.buttons.close" | translate }}</button>
    </div>
</ng-template>

<ng-template #csvExportModalTemplate>
    <div class="modal-header">
        <h4 class="modal-title">{{ "imeis.list.csvExportModal.title" | translate }}</h4>
    </div>
    <div class="modal-body row">
        <div class="col-md-12">
            <div class="form-group">
                <label>{{ "imeis.props.productType" | translate }}</label>
                <ng-select name="productType" [items]="productTypes" placeholder="" bindLabel="name" bindValue="key" [clearable]="false" [(ngModel)]="selectedProductTypeKey"> </ng-select>
                <i class="form-group__bar"></i>
                <div class="invalid-tooltip">
                    {{ "imeis.detail.validation.productType" | translate }}
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-link" (click)="exportCsv()">{{ "imeis.list.export" | translate }}</button>
        <button class="btn btn-link" (click)="csvExportModalRef?.hide()">{{ "global.buttons.close" | translate }}</button>
    </div>
</ng-template>

<div class="content__inner">
    <header class="content__title">
        <h1>{{ "imeis.list.title" | translate }}</h1>
        <small>{{ "imeis.list.subtitle" | translate }}</small>

        <div class="actions">
            <button *appHasPermission="'IMEIS.ADD'" (click)="openBulkImportModal()" class="btn btn-success btn--icon-text" type="button"><i class="zmdi zmdi-collection-plus"></i> {{ "imeis.list.upload" | translate }}</button>
            <button *appHasPermission="'IMEIS.ADD'" (click)="addImei()" class="btn btn-success btn--icon-text" style="margin-left: 25px"><i class="zmdi zmdi-collection-plus"></i> {{ "imeis.list.add" | translate }}</button>
            <button *appHasPermission="'IMEIS.LIST'" (click)="openExportModal()" class="btn btn-success btn--icon-text" style="margin-left: 25px"><i class="zmdi zmdi-download"></i> {{ "imeis.list.export" | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'IMEIS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "imeis.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="realtimeStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let row">
                            <span
                                *ngIf="row.realtimeConnectionEstablished === true || row.realtimeConnectionEstablished === false"
                                class="rounded-circle rtcDot"
                                [class.bg-success]="row.realtimeConnectionEstablished"
                                [class.bg-danger]="!row.realtimeConnectionEstablished"
                            ></span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "imeis.props.code" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.code }}</td>
                    </ng-container>

                    <ng-container matColumnDef="productType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "imeis.props.productType" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.productType }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "imeis.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "imeis.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <div class="d-flex justify-content-end">
                                <i (click)="editImei(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'IMEIS.EDIT'"></i>
                                <i (click)="deleteImei(row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'IMEIS.DELETE'"></i>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
